const DEFAULTS = {
  config: {
    toolbar: {
      hidden: []
    }
  },
  configViewer: {
    getVideoUrl: (src) => `https://video.wixstatic.com/${src.pathname}`
  }
};

export { DEFAULTS };
//# sourceMappingURL=defaults.js.map
